import React, { useState, useEffect, useCallback } from 'react';

import BtnAddHardwareModel from "../BtnAddHardwareModel"
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import HardwareModelFilter from '../HardwareModelFilters'
import { ActionTable } from '../../ActionTable/ActionTable';
import { listHardwareModels } from "../../../services/service";
import EditHardwareModelModal from '../EditHardwareModelModal';
import DeleteHardwareModelModal from '../DeleteHardwareModelModal'

const defaultHwModelData = {
    count: 0, results: [], next: null, previous: null
}
export default function HardwareModel() {
    const [hardwareModelsData, setHardwareModelsData] = useState(defaultHwModelData);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);

    const [modalStateEdit, setModalStateEdit] = useState(false);
    const [modalStateDelete, setModalStateDelete] = useState(false);

    const [modalValue, setModalValue] = useState();

    //This const will reset the index when delete a row 
    const [selectedRows, setSelectedRows] = useState(false)

    const [currentPageSize, setCurrentPageSize] = useState(25);

    const [hardwareModelsFilteredData, setHardwareModelsFilteredData] = useState();


    const loadHardwareModels = useCallback(() => {
        setLoading(true);
        listHardwareModels(currentPage + 1, currentPageSize)
            .then((response) => {
                setHardwareModelsData(response.data)
            })
            .catch((error) => {
            })
            .finally(setLoading(false))
    }, [currentPage, currentPageSize]);

    // Load All Hardware Types
    useEffect(() => {
        loadHardwareModels()
    }, [currentPage, currentPageSize, loadHardwareModels])

    const hardwareEditModelValue = (hwmModel) => {
        setModalStateEdit(true)
        setModalValue(hwmModel)
    }

    const hardwareDeleteModelValue = (hwmModel) => {
        setModalStateDelete(true)
        console.log(hwmModel)
        setModalValue(hwmModel)
    }

    const onHardwareModelCreated = (hardwareModel) => {
        loadHardwareModels()
    }

    const onHardwareEdited = (hardwareModel) => {
        loadHardwareModels()
        setModalStateEdit(false);
    }

    const onHardwareDeleted = (hardwareModel) => {
        loadHardwareModels()
        setModalStateDelete(false);
    }

    useEffect(() => {
        if (hardwareModelsFilteredData !== undefined && hardwareModelsFilteredData !== null ) {
            setHardwareModelsData(hardwareModelsFilteredData)
        }
    }, [hardwareModelsFilteredData])

    return (
        <Row>
            {modalStateEdit ?
                // Criamos o Modal, passando uma função que será chamada por ele sempre que finalizar a edição
                // (onHardwareEdited). Também passamos uma função (anônima) que será sempre chamada quando ele clicar na opção de fechar
                // Por fim, passamos os valores do hardware a ser editado (hardwareModel), juntamente com o estado atual desse modal (show)
                <EditHardwareModelModal
                    open={modalStateEdit}
                    setOpen={setModalStateEdit}
                    onHardwareModelEdited={onHardwareEdited}
                    hardwareModel={modalValue}
                    show={modalStateEdit} /> : null}

            {modalStateDelete ?
                <DeleteHardwareModelModal
                    onHardwareModelDeleted={onHardwareDeleted}
                    onClose={() => setModalStateDelete(false)}
                    hardwareModel={modalValue}
                    show={modalStateDelete}
                    loadTable={loadHardwareModels}
                    // This function will set the index to zero 
                    // Props from child to parents 
                    changeSelectedRowValue={selectedRows => setSelectedRows(selectedRows)}
                /> : null}

            <Col lg={9}>
                <HardwareModelFilter 
                    tableData={hardwareModelsData} 
                    childrenToParentValue={tableValue => setHardwareModelsFilteredData(tableValue)} 
                />
                <ActionTable
                    title={"Modelos de Hardware"}
                    enableCheck
                    currentPage={currentPage}
                    pageSize={currentPageSize}
                    pageSizeOptions={[10, 25, 40]}
                    count={hardwareModelsData.count}
                    columns={["id", "model", "manufacturer", "cpu_arch"]}
                    columnsMap={{ id: "ID", model: "Modelo", manufacturer: "Fabricante", "cpu_arch": "Arquitetura" }}
                    rows={hardwareModelsData.results}
                    onPageChange={(newPage) => setCurrentPage(newPage)}
                    onPageSizeChange={(newPageSize) => {
                        setCurrentPageSize(newPageSize)
                        setCurrentPage(1);
                    }}
                    onEditSelected={(hwModel) => hardwareEditModelValue(hwModel)}
                    // OPEN EDIT MODAL 
                    onDeleteSelected={(hw) => { hardwareDeleteModelValue(hw) }}
                    //this value will set the index to zero after delete a row 
                    SetindexToZero={selectedRows}
                // onDeleteSelected={(hwModel) => console.log(hwModel)}
                />
            </Col>
            <Col lg={3}>
                <Row>
                    <BtnAddHardwareModel onHardwareModelCreated={onHardwareModelCreated}/>
                </Row>
            </Col>
        </Row>
    )
}